import React, { Component } from 'react';
import service from '../services/paymentPartnersService';
import Modal from 'react-bootstrap/lib/Modal.js';
import style from './Modals.css';
import {API_URI} from "./../consts";
import DetailsPayment from './DetailsPayment.jsx';
import SelectRecruiters from './SelectRecruiters.jsx';

export class ModalTrigger extends Component {
    constructor(props){
        super(props);
        this.state = { visible: false };
        this.show  = () => this.setState({visible: true});
        this.hide  = () => this.setState({visible: false}, () => this.props.getPartners());
    }
    
    render(){
        return this.props.children(this.state.visible, this.show, this.hide)
    }
};

export const ModalDetailsPayment = (props) => {
    const updateRecruiterPartner = (idRecruiter) => {
        return props.onSelectUpdateRecruiter(props.partner.id, idRecruiter)
    };
    return (
        <Modal show={true} onHide={props.hideModal} dialogClassName={style.ModalDetailsPayment_modalDialog} className={style.Modal}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="row">
                        <div className="col-md-8">
                            <h4>Inventarios de operador <b>{props.partner.nombreCompleto}</b> Comuna: <b>{props.partner.comuna}</b> R: <b>{props.partner.region}</b></h4>
                        </div>
                        <SelectRecruiters
                            classname="col-md-2 col-md-offset-1"
                            recruiters={props.recruiters}
                            recruiterId={props.recruiterId}
                            onSelectRecruiterChange={updateRecruiterPartner}
                            title="Modifica el captador actual del operador"
                            disabledAll={true}
                        />
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <DetailsPayment
                    idPartner={props.partner.id}
                    clientId={props.clientId}
                    ceco={props.ceco}
                />
            </Modal.Body>
        </Modal>        
    )
};

export class ModalGeneratePayroll extends Component {
    constructor(props){
        super(props)
        this.state = {
            isLoading: false,
            showDownloadBtn: false,
            payroll: {}
        };

        this.handleGeneratePayroll = () => {
            this.setState({ isLoading: true });
            this.props.generatePayroll()
                .then(res => {
                    this.setState({showDownloadBtn: true, payroll: res.data})
                })
                .catch(error => {
                    this.setState({ isLoading: false });
                    console.log(error)
                })
        };

    }
    
    render(){
        const { pendingApproval } = this.props;
        const { isLoading, showDownloadBtn, payroll } = this.state;
        return (
            <Modal show={true} onHide={this.props.hideModal} className={style.Modal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Generar Nómina de pago
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pendingApproval ? 
                        <h4><p className="text-warning">Atención, existen operadores con servicios pendientes de aprobar, favor revisar si lo amerita.</p></h4> :
                        <h4>¿Está seguro de generar la nómina de pago?</h4>
                    }
                    {showDownloadBtn ? 
                        <div>
                            <br />
                            <h5><strong>Se ha generado la nómina de pago exitosamente.</strong></h5>
                            <a className="btn btn-xs btn-success" href={`${API_URI}excel-bank-download?payrollId=${payroll.id}&bankId=37`}>
                                Santander
                            </a>
                            <a className="btn btn-xs btn-success" href={`${API_URI}excel-bank-download?payrollId=${payroll.id}&bankId=14`}>
                                Scotiabank
                            </a>
                        </div>
                        :
                        null
                    }

                </Modal.Body>
                <Modal.Footer>
                    {pendingApproval ?
                        <button type="button" className="btn btn-warning" onClick={this.handleGeneratePayroll} disabled={isLoading}>Continuar</button> :
                        <button type="button" className="btn btn-primary" onClick={this.handleGeneratePayroll} disabled={isLoading}>Generar Nómina</button>
                    }
                    <button type="button" onClick={this.props.hideModal} className="btn btn-secondary">Cerrar</button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export class ModalVoucher extends Component {
    constructor(props){
        super(props)
        this.state = {
            isLoading: false,
            showDownloadBtn: false,
            voucherNumber: '',
            voucherTotal: '',
            voucherFile: null,
            showPartners: false,
            partnersWithProblems: []
        };

        this.handleChangeCheckBox = (evt, partner) => {
            if (evt.target.checked){
                this.setState({partnersWithProblems: [...this.state.partnersWithProblems, partner]})
            }
            else{
                let filter = this.state.partnersWithProblems.filter(p => p.id !== partner.id);
                this.setState({partnersWithProblems: filter})
            }
        };

        this.handleOnSubmit = (evt) => {
            evt.preventDefault();
            const { voucherNumber, voucherTotal, voucherFile } = this.state;
            if(voucherNumber === '' && voucherTotal === '' && !voucherFile)
                return;

            this.setState({ isLoading: true });

            let totalWithProblems = this.state.partnersWithProblems.reduce(function (accumulator, item) {
                return accumulator + item.amount;
            }, 0);

            let totalAllPartners = this.props.payroll.partners.reduce(function (accumulator, item) {
                return accumulator + item.amount;
            }, 0);
            
            let total = totalAllPartners - totalWithProblems;
            
            if(voucherTotal !== this.props.payroll.total && voucherTotal != total) {
                this.setState({showPartners: true});
                this.setState({ isLoading: false });
            }
            else{
                this.setState({showPartners: false});
                let withProblems = JSON.stringify(this.state.partnersWithProblems);
                const formData = new FormData();
                formData.append('voucherFile', voucherFile);
                formData.append('payrollId', this.props.payroll.payrollId);
                formData.append('voucherNumber', voucherNumber);
                formData.append('voucherTotal', voucherTotal);
                formData.append('partnersWithProblems', withProblems);
                service.createVoucherPayroll(formData)
                    .then(this.props.hideModal)
                    .catch(error => console.log(error));
            }
        };
        
        this.handleChange = (evt) => {
            const { value, name } = evt.target;
            this.setState({ [name]: value });
        };
        
        this.handleChangeFile = (evt) => {
            if(evt.target.files[0]){
                let file = evt.target.files[0];
                this.setState({ voucherFile: file });
            }
        }
    }
    render(){
        return(
            <Modal show={true} onHide={this.props.hideModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Subir comprobante depósito</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.state.showPartners &&
                    <div>
                        <p>El total del voucher presenta diferencias, por favor indique los operadores que presentaron problemas para dejar pendiente el pago.</p>
                        <table className="table">
                            <thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Nombre</th>
                                <th scope="col">RUT</th>
                                <th scope="col">Monto</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.payroll.partners.map((partner, idx) => (
                                <tr>
                                    <td>{idx + 1}</td>
                                    <td>{partner.name}</td>
                                    <td>{partner.rutDV}</td>
                                    <td>{partner.amount}</td>
                                    <td>
                                        <input
                                            type="checkbox"
                                            onChange={evt => this.handleChangeCheckBox(evt, partner)}
                                        />
                                    </td>
                                </tr>
                            ))}

                            </tbody>
                        </table>
                    </div>
                    }
                    {this.props.vouchers.length > 0 ?
                        this.props.vouchers.map((voucher, idx) => (
                            <div className={style.ModalVoucher__divListVouchers} key={idx}>
                                <label>Voucher {idx + 1}</label>
                                <div className="form-group">
                                    <div className="col-md-5">
                                        <label>Cargado por:</label>
                                        <label>{voucher.uploadBy}</label>
                                    </div>
                                    <div className="col-md-5">
                                        <label>Fecha:</label>
                                        <label>{voucher.dateTimeUpload}</label>
                                    </div>
                                    <div className="col-md-2">
                                        <a className="btn btn-xs btn-success" disabled>Descargar</a>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="col-md-5">
                                        <label>Código:</label>
                                        <label>{voucher.codeTransaction}</label>
                                    </div>
                                    <div className="col-md-5">
                                        <label>Total:</label>
                                        <label>{voucher.total.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</label>
                                    </div>

                                </div>
                            </div>
                        ))
                        :
                        <form onSubmit={this.handleOnSubmit}>
                            <label>Nuevo Voucher</label>
                            <div className="form-group">
                                <label>Código Transacción</label>
                                <input
                                    type="number"
                                    onChange={this.handleChange}
                                    className="form-control"
                                    name="voucherNumber"
                                    value={this.state.voucherNumber}
                                    placeholder="Ingresa número de voucher"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Total Voucher</label>
                                <input
                                    type="number"
                                    onChange={this.handleChange}
                                    className="form-control"
                                    name="voucherTotal"
                                    value={this.state.voucherTotal}
                                    placeholder="Ingresa total voucher"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Adjuntar Voucher</label>
                                <input
                                    type="file"
                                    onChange={this.handleChangeFile}
                                    className="form-control-file"
                                    name="fileVoucher"
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary" disabled={this.state.isLoading}>Guardar</button>
                        </form>
                    }
                </Modal.Body>
            </Modal>
        )
    }
};


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/Modals.jsx